/**
 * Product card image gallery: prev/next arrows on .tb-pcard__track.
 */
(function () {
  'use strict';

  function getTrack(root) {
    return root && root.querySelector('.tb-pcard__track');
  }

  function getVisibleSlides(track) {
    return Array.from(track.querySelectorAll('.tb-pcard__slide')).filter(function (slide) {
      return !slide.classList.contains('vli-hidden') && !slide.hidden;
    });
  }

  function getCurrentIndex(track, visible) {
    var best = 0;
    var minDist = Infinity;
    visible.forEach(function (slide, i) {
      var dist = Math.abs(slide.offsetLeft - track.scrollLeft);
      if (dist < minDist) {
        minDist = dist;
        best = i;
      }
    });
    return best;
  }

  function scrollToSlide(track, slide) {
    track.scrollTo({
      left: slide.offsetLeft,
      behavior: 'smooth',
    });
  }

  function updateProgress(root) {
    var track = getTrack(root);
    var progressWrap = root && root.querySelector('[data-pcard-gallery-progress]');
    if (!track || !progressWrap) return;

    var visible = getVisibleSlides(track);
    var fill = progressWrap.querySelector('.tb-pcard__gallery-progress-fill');
    var bar = progressWrap.querySelector('[role="progressbar"]');

    if (visible.length <= 1) {
      progressWrap.hidden = true;
      return;
    }

    progressWrap.hidden = false;

    var idx = getCurrentIndex(track, visible);
    var percent = ((idx + 1) / visible.length) * 100;
    var firstLeft = visible[0].offsetLeft;
    var lastLeft = visible[visible.length - 1].offsetLeft;
    var range = lastLeft - firstLeft;

    if (range > 0) {
      var t = (track.scrollLeft - firstLeft) / range;
      t = Math.min(1, Math.max(0, t));
      percent = ((t * (visible.length - 1) + 1) / visible.length) * 100;
    }

    if (fill) {
      fill.style.width = percent + '%';
    }
    if (bar) {
      bar.setAttribute('aria-valuenow', String(idx + 1));
      bar.setAttribute('aria-valuemax', String(visible.length));
    }
  }

  function updateNavState(root) {
    var track = getTrack(root);
    var nav = root && root.querySelector('[data-pcard-gallery-nav]');
    if (!track) return;

    var visible = getVisibleSlides(track);
    var multi = visible.length > 1;

    track.classList.toggle('tb-pcard__track--single', !multi);
    if (multi) {
      track.setAttribute('tabindex', '0');
      if (!track.getAttribute('aria-label')) {
        track.setAttribute('aria-label', 'Product images');
      }
    } else {
      track.removeAttribute('tabindex');
    }

    updateProgress(root);

    if (!nav) return;

    var prev = nav.querySelector('.tb-pcard__gallery-prev');
    var next = nav.querySelector('.tb-pcard__gallery-next');

    if (!multi) {
      nav.hidden = true;
      if (prev) {
        prev.hidden = true;
        prev.disabled = true;
      }
      if (next) {
        next.hidden = true;
        next.disabled = true;
      }
      return;
    }

    nav.hidden = false;
    var idx = getCurrentIndex(track, visible);
    var atStart = idx <= 0;
    var atEnd = idx >= visible.length - 1;

    if (prev) {
      prev.hidden = atStart;
      prev.disabled = atStart;
    }
    if (next) {
      next.hidden = atEnd;
      next.disabled = atEnd;
    }
  }

  function resetGalleryToStart(root) {
    var track = getTrack(root);
    if (!track) return;

    track.scrollLeft = 0;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var visible = getVisibleSlides(track);
        if (visible.length) {
          track.scrollTo({ left: visible[0].offsetLeft, behavior: 'auto' });
        } else {
          track.scrollLeft = 0;
        }
        updateNavState(root);
      });
    });
  }

  function syncCard(root) {
    if (!root) return;
    updateNavState(root);
  }

  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('.tb-pcard__gallery-prev');
    var nextBtn = e.target.closest('.tb-pcard__gallery-next');
    if (!prevBtn && !nextBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var root = (prevBtn || nextBtn).closest('[data-pcard-root]');
    var track = getTrack(root);
    if (!root || !track) return;

    var visible = getVisibleSlides(track);
    if (visible.length <= 1) return;

    var idx = getCurrentIndex(track, visible);
    if (prevBtn && idx > 0) {
      scrollToSlide(track, visible[idx - 1]);
    } else if (nextBtn && idx < visible.length - 1) {
      scrollToSlide(track, visible[idx + 1]);
    }

    setTimeout(function () {
      updateNavState(root);
    }, 350);

    requestAnimationFrame(function () {
      updateProgress(root);
    });
  });

  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target;
      if (!track.classList || !track.classList.contains('tb-pcard__track')) return;
      var root = track.closest('[data-pcard-root]');
      if (root) updateNavState(root);
    },
    true
  );

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.product-variant-value')) return;
    var root = e.target.closest('[data-pcard-root]');
    if (!root) return;
    resetGalleryToStart(root);
  });

  function initVisibleCards() {
    document.querySelectorAll('[data-pcard-root]').forEach(function (root) {
      resetGalleryToStart(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisibleCards);
  } else {
    initVisibleCards();
  }

  document.addEventListener('shopify:section:load', initVisibleCards);

  var initScheduled = null;
  function scheduleInitVisibleCards() {
    if (initScheduled) return;
    initScheduled = requestAnimationFrame(function () {
      initScheduled = null;
      initVisibleCards();
    });
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('[data-pcard-root]')) ||
            (node.querySelector && node.querySelector('[data-pcard-root]'))
          ) {
            scheduleInitVisibleCards();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.TypeBeautyPcardGallery = {
    syncCard: syncCard,
    resetGalleryToStart: resetGalleryToStart,
    initVisibleCards: initVisibleCards,
  };
})();
